var map = {
	"./1.png": 96651,
	"./10.png": 53498,
	"./11.png": 66659,
	"./12.png": 37719,
	"./2.png": 20029,
	"./3.png": 31923,
	"./4.png": 87353,
	"./5.png": 23585,
	"./6.png": 74936,
	"./7.png": 2113,
	"./8.png": 90931,
	"./9.png": 16651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47803;